/* eslint-disable @typescript-eslint/naming-convention */
import { isEmptyObject } from '@helpers';
import { appStore } from '@store';
import { SurveyAnswers } from '@verv-inc/js-questionnaire';
import { METRICS } from '@types';
import { IHeightAnswer } from './unitsHelpers';

export const getAnswersToSend = (answers: SurveyAnswers): Record<string, any> | undefined => {
	if (!answers) return undefined;
	const { weight, height, target_weight, mail, agreeToInbox, intermittent_fasting } = answers;
	const { params } = appStore;
	const { gender } = params;

	const result: Record<string, any> = {};

	Object.entries(answers).forEach(([question, answer]) => {
		const answers: any = {};
		answer?.forEach(item => {
			answers[item] = {
				value: item,
			};
		});
		result[question] = isEmptyObject(answers)
			? undefined
			: {
					answers,
			  };

		result.agreeToInbox = undefined;
		result.workouts_preferences = undefined;

		if (gender) {
			result.gender = {
				answers: {
					value: gender,
				},
			};
		}

		if (intermittent_fasting != null) {
			result.intermittent_fasting = {
				answers: {
					value: intermittent_fasting.join() === 'true',
				},
			};
		}

		if (height != null) {
			const { unit: heightUnit, value: height_value }: IHeightAnswer = JSON.parse(height.join());
			const value =
				heightUnit === METRICS.FT
					? +(height_value?.[0]?.value as string) * 12 + +(height_value?.[1]?.value as string)
					: height_value?.[0]?.value;

			result.height = {
				answers: {
					units: { value: heightUnit === METRICS.FT ? METRICS.IN : METRICS.CM },
					value: { value: value?.toString() },
				},
			};
		} else {
			result.height = undefined;
		}

		if (target_weight != null) {
			const { unit, value } = JSON.parse(target_weight.join());
			result.target_weight = {
				answers: {
					units: { value: unit },
					value: { value },
				},
			};
		} else {
			result.target_weight = undefined;
		}

		if (weight != null) {
			const { unit, value } = JSON.parse(weight.join());
			result.weight = {
				answers: {
					units: { value: unit },
					value: { value },
				},
			};
		} else {
			result.weight = undefined;
		}

		if (mail != null) {
			result.mail = {
				answers: {
					value: mail.join(),
					agreeToInbox: agreeToInbox?.join() === 'true',
				},
			};
		}

		// kostyl to pass age_male to ios client as age and prevent extra client release
		if (result.age_male && !result.age) {
			result.age = { ...result.age_male };
			result.age_male = undefined;
		}
	});

	return result;
};
